import { render, staticRenderFns } from "./WelcomeAfterSignUp.vue?vue&type=template&id=8393d0f2&scoped=true&"
import script from "./WelcomeAfterSignUp.vue?vue&type=script&lang=js&"
export * from "./WelcomeAfterSignUp.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeAfterSignUp.vue?vue&type=style&index=0&id=8393d0f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8393d0f2",
  null
  
)

export default component.exports